export default __webpack_public_path__ + "static/media/Armbands of Swiftstriking.1bd21f33.jpg";